import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectDefault from "@/src/components/SelectDefault/SelectDefault";
import { officeAccountingHeaderSelectConst } from "@/src/constants/officeAccountingTableConfig";
import { setActualOfficeTable } from "@/src/store/slices/OfficeAccountingPage/officeAccountingFiltersSlice";
import { RootState } from "@/src/store";
import { isOfficeSwitcherLocked } from "@/src/constants/accessControl";

const HeaderOfficeAccounting = () => {
  const dispatch = useDispatch();
  const hasFullCountryAccess = useSelector((state: RootState) => state.accessControl.hasFullCountryAccess);
  const allowedOffices = useSelector((state: RootState) => state.accessControl.allowedOffices);
  const actualOfficeTable = useSelector((state: RootState) => state.officeAccountingFilters.actualOfficeTable);
  const campusFilter = useSelector((state: RootState) => state.officeAccountingFilters.filterResults.campus);
  const isCampusFilterActive = Array.isArray(campusFilter) && campusFilter.length > 0;
  const isOfficeSelectDisabled =
    isOfficeSwitcherLocked(hasFullCountryAccess, allowedOffices) || isCampusFilterActive;

  const officeOptions = useMemo(() => {
    if (hasFullCountryAccess || isCampusFilterActive) return officeAccountingHeaderSelectConst;
    return allowedOffices
      .map((office) => officeAccountingHeaderSelectConst.find((item) => item.id === office))
      .filter((item): item is (typeof officeAccountingHeaderSelectConst)[number] => Boolean(item));
  }, [allowedOffices, hasFullCountryAccess, isCampusFilterActive]);

  const handleOfficeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (isOfficeSelectDisabled) return;
    dispatch(setActualOfficeTable(event.target.value));
  };

  return (
    <div className={`header-office-accounting ${isOfficeSelectDisabled ? "disabled" : ""}`}>
      <SelectDefault
        onChange={handleOfficeChange}
        value={isCampusFilterActive ? "ALL" : actualOfficeTable || "ALL"}
        disabled={isOfficeSelectDisabled}
      >
        {officeOptions.map((item) => (
          <option value={item.id} key={item.id}>
            {item.title}
          </option>
        ))}
      </SelectDefault>
    </div>
  );
};

export default HeaderOfficeAccounting;
